import HttpRequest from '@/util/HttpRequest'

const KEY_HOME_NOTIFICATION = 'home_notification'

export default {
  namespaced: true,
  state: {
    homeNotification: {}
  },
  mutations: {
    LOAD_HOME_NOTIFICATION (state, data) {
      state.homeNotification = JSON.parse(data.config)
    },
  },
  actions: {
    // 결재 요청함 추가/수정
    async SAVE_HOME_NOTIFICATION ({commit}, params) {
      // boardSlug = '' 인 경우 모든 게시판에 대해서 가져온다.
      const option = {
        key: KEY_HOME_NOTIFICATION,
        config: JSON.stringify(params.config)
      }
      return new Promise((resolve, reject) => {
        HttpRequest.post('/api/v1/config', option)
          .then(response => {
            commit('LOAD_HOME_NOTIFICATION', response)
            resolve(response)
          }).catch(err => reject(err))
      })
    },

    // 결재 요청함 불러오기
    async LOAD_HOME_NOTIFICATION ({commit}) {
      // boardSlug = '' 인 경우 모든 게시판에 대해서 가져온다.
      const option = {
        params: {
          key: KEY_HOME_NOTIFICATION
        }
      }
      return new Promise((resolve, reject) => {
        HttpRequest.get('/api/v1/config', option)
          .then(response => {
            commit('LOAD_HOME_NOTIFICATION', response)
            resolve(response)
          }).catch(err => reject(err))
      })
    },

    /**
     * MaotConfig 모델에서 조회한다
     */
    async LOAD_CONFIG ({}, params) {
      const option = {
        params: {
          key: params.key,
        }
      }
      return new Promise((resolve, reject) => {
        HttpRequest.get(`/api/v1/config`, option)
          .then(response => {
            try {
              const config = JSON.parse(response.config)
              resolve(config)
            } catch (e) {
              resolve(undefined);
            }
          }).catch(err => reject(err))
      })
    },
  },
  getters: {}
}
